// Template detail page (CHG-1261 / ITER-3386).
//
// Thin per the v12 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates templateDetailConfig from
// template.entity-hint.yaml (CHG-1235) without touching this file.
//
// Spec: specs/tier-05-experience/template-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { templateDetailConfig } from "../generated/screens/template-detail";

export function TemplateDetail() {
  return <DetailPage config={templateDetailConfig} />;
}
